import { ReactElement } from 'react';

import { ArrowLeftIcon, ArrowRightIcon, ChevronDownIcon } from '../../../icons';

export type NavChevronProps = {
  className?: string;
  orientation?: 'left' | 'right' | 'up' | 'down';
};

/** Стрелки навигации/шеврон выпадающего списка месяца-года (вместо дефолтного шеврона react-day-picker). */
const NavChevron = ({ className, orientation }: NavChevronProps): ReactElement => {
  if (orientation === 'right') {
    return <ArrowRightIcon className={className} />;
  }

  if (orientation === 'down') {
    return <ChevronDownIcon className={className} />;
  }

  return <ArrowLeftIcon className={className} />;
};

export default NavChevron;
